import { Tooltip } from '~/components';

import { TruncateWithTooltip } from './TruncateWithTooltip';

interface GroupInfoProps {
  groups: string[];
}

export function GroupInfo({ groups }: GroupInfoProps) {
  if (!groups?.length) {
    return '-';
  }

  const [groupName, ...restGroups] = groups;

  return (
    <div className="flex items-center justify-between gap-xs">
      <TruncateWithTooltip>{groupName}</TruncateWithTooltip>
      {groups.length > 1 ? (
        <Tooltip
          content={restGroups.join(', ')}
          side="top"
          delayDuration={0}
          contentClassName="max-h-[13rem] overflow-y-auto"
        >
          <span className="ml-md basis-md rounded-xs border px-sm py-xs text-center text-body-xs leading-5 bg-level-05 border-emphasis-subtle">
            +{restGroups.length}
          </span>
        </Tooltip>
      ) : null}
    </div>
  );
}

GroupInfo.displayName = 'GroupInfo';
